import { render, staticRenderFns } from "./late-payment4.vue?vue&type=template&id=be882e5c&"
import script from "./late-payment4.vue?vue&type=script&lang=js&"
export * from "./late-payment4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports